import React, { useEffect } from "react";
import { App, ConfigProvider } from "antd";
import { createRoot } from 'react-dom/client';
import { customTheme } from "common/customTheme";
import { EditableContextProvider } from "common/EditableContextProvider";
import { useInstances } from "../Hooks/useInstances";
import ErrorBox from "common/ErrorBox";
import QRCode from "react-qr-code";
import { ApiConnector } from "common/ApiConnector";

export default function Main({cat_user_id}) {
    const context = useInstances(cat_user_id);

    useEffect(() => {

        context.updateToken().then(() => {
            context.getInfo().then(data => context.WSock.connect(data.code));
        })

        return () => {
            context.WSock.disconnect();
        }
    }, []);

    return (
        <div>
            <EditableContextProvider data={{ context }} >
                <div className="ant-table-title px-3 py-3 rounded my-2" style={{ margin: '0px 0em' }}>
                    <div className="px-3" style={{ fontSize: '1.25rem' }}>Instancia</div>
                </div>
                <div className="row p-3 rounded">
                    <div className="col-md-3 mb-3">
                        {
                            (context.info.status === "RUNNING" &&
                                context.info.auth_status === "AUTHENTICATED") ? (
                                <div>
                                    <img
                                        className="w-100"
                                        src={`${ApiConnector.defaults.baseURL}/img/connected.gif`}
                                    />
                                    <button className="btn btn-sm btn-danger w-100"
                                        onClick={async () => {
                                            await context.node.stop();
                                        }}
                                    >Detener</button>
                                </div>
                            ) : null
                        }
                        {
                            (context.info.status === "RUNNING" &&
                                context.info.auth_status === "UNAUTHENTICATED") ? (
                                <div>
                                    <QRCode
                                        className="w-100 mb-2"
                                        value={context.info?.qr ?? ""}
                                        level="M"
                                        title="Authenticate QR"
                                    />
                                    <button className="btn btn-sm btn-danger w-100"
                                        onClick={async () => {
                                            await context.node.stop();
                                        }}
                                    >Detener</button>
                                </div>
                            ) : (<></>)
                        }
                        {
                            (context.info.status === "STOPPED") ? (
                                <>
                                    <img
                                        className="w-100"
                                        src={`${ApiConnector.defaults.baseURL}/img/no-connected.jpg`}
                                    />
                                    <div className="mt-2">
                                        <button className="btn btn-sm btn-success w-100"
                                            onClick={async () => {
                                                await context.node.start();
                                            }}
                                            disabled={(context.info.status === "RUNNING")}
                                        >
                                            {
                                                (context.info.status === "STOPPED") ?
                                                    "Conectar" : "Connectando..."
                                            }
                                        </button>
                                    </div>
                                </>
                            ) : (<></>)
                        }
                    </div>
                    <div className="col-md-9">
                        <table className="table table-bordered ">
                            <tbody>
                                <tr>
                                    <td>Usuario:</td>
                                    <td className="fw-bold">{context.info.user?.name}</td>
                                </tr>
                                <tr>
                                    <td>Número de instancia:</td>
                                    <td className="fw-bold">{context.info.auth_number ? `+${context.info.auth_number}` : ''}</td>
                                </tr>
                                <tr>
                                    <td>Código:</td>
                                    <td>{context.info.code}</td>
                                </tr>
                                <tr>
                                    <td>Estado:</td>
                                    <td>{context.info.status}</td>
                                </tr>
                                <tr>
                                    <td>Autenticación:</td>
                                    <td>{context.info.auth_status}</td>
                                </tr>
                                <tr>
                                    <td>
                                        <label htmlFor="keep_online">
                                            Mantener iniciado:
                                        </label>
                                    </td>
                                    <td>
                                        <input id="keep_online" name="keep_online" type="checkbox" disabled={context.node.updatingCheckbox}
                                            checked={context.info.keep_online ?? false}
                                            onChange={(e) => {
                                                context.node.updateKeepOnline(e.currentTarget.checked)
                                            }}
                                        />
                                        {
                                            context.node.updatingCheckbox ? (
                                                <span className="ms-2 mt-0 text-secondary">Actualizando...</span>
                                            ) : (
                                                <></>
                                            )
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td>
                                        <button className="btn btn-sm btn-danger"
                                            onClick={() => context.node.reset()}
                                        >
                                            <i className="fas fa-xmark me-2"></i>
                                            Eliminar datos de autenticación
                                        </button>

                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="col-md-2"></div>
                </div>


            </EditableContextProvider>
        </div>
    )
}

let main = document.getElementById('instances-main');

if (main) {
    let cat_user_id = main.dataset.catUserId;
    if (!main.root) { main.root = createRoot(main); }
    main.root.render(
        <React.StrictMode>
            <ErrorBox>
                <ConfigProvider theme={customTheme}>
                    <App >
                        <Main cat_user_id={cat_user_id}/>
                    </App>
                </ConfigProvider>
            </ErrorBox>
        </React.StrictMode>
    );
}
